import { useEffect, useRef, useState } from "react";
import "./KebabMenu.css";

export default function KebabMenu({ items = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // закрытие по клику вне меню
  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  // простая клавиатурная доступность: Enter/Space на кнопке
  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setOpen((v) => !v);
    }
    if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="kebab-wrapper" ref={ref}>
      <button
        type="button"
        className="kebab-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="More actions"
        onClick={() => setOpen((v) => !v)}
        onKeyDown={onKeyDown}
      >
        ⋯
      </button>

      {open && (
        <div className="kebab-menu" role="menu">
          {items.map((it, idx) => (
            <button
              key={idx}
              type="button"
              role="menuitem"
              className="kebab-item"
              onClick={() => {
                setOpen(false);
                it.onClick?.();
              }}
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}